#import "../fragments/field-fragment.graphql"

mutation CreateField($input: FieldCreateInput!) {
    fieldCreate(input: $input) {
        field {
            ...FieldFragment
        }
    }
}
